/*
 * Copyright (c) 2021. Dave van Rijn Development
 */

import React from 'react';
import {Switch} from "./switch";
import {ControlContext} from "../util/controlContext";
import {generateComponentId} from '../../..';

interface SwitchProps {
    onChange: Function,
    onMouseEnter?: Function,
    onMouseLeave?: Function,
    value: boolean,
    labels: string[],
    mainLabel: string;
    baseColor?: string,
    trackColor: string,
    offColor: string,
    containerClass: string,
    labelClass: string,
    switchClass: string,
    trackClass: string,
    mainLabelClass: string;
    id?: string,
    padding: 'small' | 'standard' | 'large',
    disabled: boolean,
}

interface SwitchState {
    isHovered: boolean,
}

// noinspection JSUnusedGlobalSymbols
export default class SwitchController extends React.Component<SwitchProps, SwitchState> {
    declare context: React.ContextType<typeof ControlContext>
    static contextType = ControlContext;

    static defaultProps = {
        labels: [],
        trackColor: 'color-gray-4',
        offColor: '',
        containerClass: '',
        labelClass: '',
        switchClass: '',
        trackClass: '',
        mainLabelClass: '',
        padding: 'standard',
        disabled: false,
        mainLabel: '',
    };

    state = {
        isHovered: false,
    };

    private id: string = generateComponentId(this.props.id);

    onChange = (evt: any) => {
        const {value, onChange, disabled} = this.props;
        if (!disabled)
            onChange(!value, evt);
    };

    onMouseEnter = (evt: any) => {
        const {onMouseEnter} = this.props;
        this.setState({isHovered: true});
        if (onMouseEnter !== undefined && onMouseEnter !== null)
            onMouseEnter(evt);
    };

    onMouseLeave = (evt: any) => {
        const {onMouseLeave} = this.props;
        this.setState({isHovered: false});
        if (onMouseLeave !== undefined && onMouseLeave !== null)
            onMouseLeave(evt);
    };

    getBaseColor = (): string => {
        const {baseColor} = this.props;
        if (baseColor !== undefined && baseColor !== null) return baseColor;
        // noinspection JSDeprecatedSymbols
        return this.context.baseColor;
    };

    render = () => {
        const {
            value, labels, trackColor, offColor, containerClass, labelClass, trackClass, switchClass,
            padding, disabled, mainLabel, mainLabelClass
        } = this.props, {isHovered} = this.state;
        return <Switch onChange={this.onChange} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}
                       value={value} labels={labels} baseColor={this.getBaseColor()} trackColor={trackColor}
                       offColor={offColor} id={this.id} containerClass={containerClass} labelClass={labelClass}
                       switchClass={switchClass} trackClass={trackClass} padding={padding} disabled={disabled}
                       isHovered={isHovered} label={mainLabel} mainLabelClass={mainLabelClass}/>
    }
}